import * as React from 'react';
import Radium from '@flipdish/radium';
import { ReactNode, useRef, useState } from 'react';
import { connect } from 'react-redux';

const _ = require('lodash');

type TRadiumResult = {
  _state: any;
  updateState: (newState) => void;
  isActive: (propKey) => string;
  isHover: (propKey) => string;
};
// Helper hook for possibility usage Radium inside FC. Use it only with RadiumContainer component.
// Use it for code movement from class components to FC components.
// Warning! Don't write new code with radium.This hook should use only for code-movement and will be removed in future.
// For new code use material-ui
export const useRadium = (): TRadiumResult => {
  const [, refresh] = useState();
  const ref = useRef<TRadiumResult>({
    _state: {},
    updateState: (newState) => {
      ref.current._state = newState;
      refresh(newState);
    },
    isActive: (propKey) => {
      return Radium.getState(ref.current._state, propKey, ':active');
    },
    isHover: (propKey) => Radium.getState(ref.current._state, propKey, ':hover')
  });
  return ref.current;
};

interface Props {
  radium: TRadiumResult;
  children: ReactNode;
}

class RadiumComponent extends React.Component<Props, {}> {
  shouldComponentUpdate(
    nextProps: Readonly<Props>,
    nextState: Readonly<{}>,
    nextContext: any
  ): boolean {
    if (!_.isEqual(this.state, nextState)) {
      this.props.radium.updateState(nextState);
    }
    return true;
  }

  public render(): JSX.Element | null {
    return <>{this.props.children}</>;
  }
}

export const RadiumContainer = connect<{}, {}, Props>(null, null)(Radium(RadiumComponent));
